import { DatePicker, Select, Table, Tag } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { useParams } from "react-router-dom";
import { loadExpensesById } from "../../redux/rtk/features/expense/expenseSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import ViewBtn from "../Buttons/ViewBtn";
import BtnViewSvg from "../UI/Button/btnViewSvg";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");


const { Option } = Select;

function CustomTable({ list, loading, currentPage, pageSize, onPageChange }) {
	const [columnsToShow, setColumnsToShow] = useState([]);
	const { RangePicker } = DatePicker;
	const [fromDate, setFromDate] = useState(dayjs().startOf("month").format("YYYY-MM-DD"));
	const [toDate, setToDate] = useState(dayjs().endOf("month").format("YYYY-MM-DD"));
	const [filteredList, setFilteredList] = useState([]);
	const [selectedProject, setSelectedProject] = useState(null);

	const totalExpenseAmount = filteredList.reduce(
		(acc, item) => acc + (Number(item.expenseAmount) || 0),
		0
	);
	const projects = useSelector((state) => state.expenseProject.list);

	// Function to map projectId to projectName (fallback when projectName not in item)
	const mapProjectName = (projectId, projectName) => {
		if (projectName) return projectName;
		const project = (projects || []).find((p) => p.id === projectId || p.ProjectId === projectId);
		return project ? (project.name || project.ProjectName) : projectId;
	};

	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));




	const columns = [
		{
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
			render: (text, record, index) => index + 1,
		},
		{
			title: "User Name",
			dataIndex: "user",
			key: "user",
			render: (user) => `${user?.firstName || ''} ${user?.lastName || ''}`,
		},
		{
			title: "Project",
			dataIndex: "projectId",
			key: "projectId",
			render: (projectId, record) =>
				mapProjectName(projectId, record.projectName),
		},

		{
			title: "Expense Title",
			dataIndex: "expenseTitle",
			key: "expenseTitle",
		},
		{
			title: "Expense Amount",
			dataIndex: "expenseAmount",
			key: "expenseAmount",
		},
		{
			title: "Expense Date",
			dataIndex: "expenseDate",
			key: "expenseDate",
			render: (expDate) => dayjs(expDate).format("DD-MMM-YYYY"),
			onFilter: (value, record) => {
				if (!fromDate || !toDate) {
					return true;
				}
				const expDate = dayjs(record.expenseDate).format("YYYY-MM-DD");
				return expDate >= fromDate && expDate <= toDate;
			},
		},
		// {
		// 	title: "Expense Proof",
		// 	dataIndex: "expenseProofUrl",
		// 	key: "expenseProof",
		// 	render: (url) => {
		// 		if (!url) {
		// 			return null;
		// 		}
		// 		const fileType = url.split(".").pop().toLowerCase();
		// 		if (["jpg", "jpeg", "png", "gif", "bmp"].includes(fileType)) {
		// 			return (
		// 				<img
		// 					src={url}
		// 					alt="Proof"
		// 					style={{ maxWidth: "100px", maxHeight: "100px" }}
		// 				/>
		// 			);
		// 		} else if (["pdf"].includes(fileType)) {
		// 			return (
		// 				<embed src={url} type="application/pdf" width="100" height="100" />
		// 			);
		// 		} else if (["xls", "xlsx"].includes(fileType)) {
		// 			return (
		// 				<iframe
		// 					src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
		// 						url
		// 					)}`}
		// 					width="100"
		// 					height="100"
		// 					frameborder="0"
		// 				/>
		// 			);
		// 		} else if (["doc", "docx"].includes(fileType)) {
		// 			return (
		// 				<iframe
		// 					src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
		// 						url
		// 					)}`}
		// 					width="100"
		// 					height="100"
		// 					frameborder="0"
		// 				/>
		// 			);
		// 		} else {
		// 			return <a href={url}>Download</a>;
		// 		}
		// 	},
		// },

		{
			title: "Status",
			dataIndex: "approvalStatus",
			key: "status",
			render: (status) => {
				const s = (status || "").toUpperCase();
				if (s === "APPROVED") {
					return <Tag color="green">{(status || "").toUpperCase()}</Tag>;
				} else if (s === "REJECTED") {
					return <Tag color="red">{(status || "").toUpperCase()}</Tag>;
				} else if (s === "PARTIAL APPROVE" || s === "PARTIALLY APPROVED") {
					return <Tag color="orange">{(status || "").toUpperCase()}</Tag>;
				} else {
					return <Tag color="yellow">{(status || "").toUpperCase() || "PENDING"}</Tag>;
				}
			},
		},


		{
			// id: 7,
			title: "Action",
			key: "action",
			render: ({ id }) => (
				<ViewBtn
					path={`/admin/expense/${id}`}
					text="View"
					icon={<BtnViewSvg />}
				/>
			),
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	// useEffect(() => {
	// 	if (list) {
	// 	  const filtered = list.filter(item => {
	// 		const expDate = moment(item.expenseDate).format("YYYY-MM-DD");
	// 		return expDate >= fromDate && expDate <= toDate;
	// 	  });
	// 	  setFilteredList(filtered);
	// 	} else {
	// 	  setFilteredList([]);
	// 	}
	//   }, [fromDate, toDate, list]);

	//   const columnsToShowHandler = (val) => {
	// 	setColumnsToShow(val);
	//   };

	useEffect(() => {
		if (list && list.length) {
			const filtered = list.filter((item) => {
				const expDate = dayjs(item.expenseDate).format("YYYY-MM-DD");
				const matchesDateRange = expDate >= fromDate && expDate <= toDate;
				const projectLabel = mapProjectName(item.projectId, item.projectName);
				const matchesProject =
					!selectedProject || projectLabel === selectedProject;
				return matchesDateRange && matchesProject;
			});
			setFilteredList(filtered);
		} else {
			setFilteredList([]);
		}
	}, [fromDate, toDate, list, selectedProject]);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	return (
		<div className="ant-card p-4 rounded mt-5">
			<div className="flex my-2 justify-between">
				<div className="w-50">
					<h4 className="text-2xl mb-2"> My Expense Forms</h4>
				</div>
				<div>
					<RangePicker
						defaultValue={[dayjs().startOf("month"), dayjs().endOf("month")]}
						onChange={(dates) => {
							if (dates) {
								setFromDate(dayjs(dates[0]).format("YYYY-MM-DD"));
								setToDate(dayjs(dates[1]).format("YYYY-MM-DD"));
							}
						}}
					/>
				</div>

				<div>
					<Select
						placeholder="Select Project"
						style={{ width: 200 }}
						onChange={(value) => setSelectedProject(value)}
						allowClear
					>
						{(projects||[]).map((project) => (
							<Option key={project.id} value={project.name}>
								{project.name}
							</Option>
						))}
					</Select>
				</div>
				{filteredList && (
					<div className="flex justify-end mr-4">
						<div className="mt-0.5">
							<CsvLinkBtn>
								<CSVLink
									data={filteredList}
									className="btn btn-dark btn-sm"
									style={{ marginTop: "5px" }}
									filename="expense_forms"
								>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>
					</div>
				)}
			</div>
			{filteredList && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}
			<Table
				className="text-center"
				scroll={{ x: true }}
				loading={loading}
				columns={columnsToShow}
				dataSource={
					filteredList.map((item, index) => ({ ...item, key: index }))
				}
				
				pagination={{
					current: currentPage,
					pageSize: pageSize,
					total: filteredList.length,
				}}
				summary={() => (
					<Table.Summary.Row>
						<Table.Summary.Cell></Table.Summary.Cell>
						<Table.Summary.Cell>Total Expense Amount:</Table.Summary.Cell>
						<Table.Summary.Cell>{totalExpenseAmount.toFixed(2)}</Table.Summary.Cell>
						<Table.Summary.Cell></Table.Summary.Cell>
						<Table.Summary.Cell></Table.Summary.Cell>
						<Table.Summary.Cell></Table.Summary.Cell>
						<Table.Summary.Cell></Table.Summary.Cell>
					</Table.Summary.Row>
				)}
			/>
		</div>
	);
}

// Normalize ExpenseById API response to table shape
const normalizeExpensesById = (rawList = []) =>
	Array.isArray(rawList)
		? rawList.map((item) => ({
				id: item.ExpenseId ?? item.expenseId ?? item.Id ?? item.id,
				expenseAmount: item.Amount ?? item.amount ?? 0,
				expenseDate: item.ExpenseDate ?? item.expenseDate,
				projectId: item.ProjectId ?? item.projectId,
				projectName: item.ProjectName ?? item.projectName,
				expenseTitle: item.ExpanseTypeName ?? item.ExpenseTypeName ?? item.expenseTitle,
				approvalStatus: item.ExpenseStatusName ?? item.expenseStatusName ?? item.approvalStatus,
				user: item.user ?? { firstName: "", lastName: "" },
		  }))
		: [];

const UserExpense = (props) => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const rawList = useSelector((state) => state.expense.expensesById) ?? [];
	const list = normalizeExpensesById(rawList);
	const loading = useSelector((state) => state.expense.loading);

	useEffect(() => {
		// API expects EmployeeId as BigInt (numeric). Some routes pass a placeholder like "{user}".
		const tokenEmployeeId = getUserFromToken();
		const resolvedEmployeeId =
			typeof id === "string" && /^\d+$/.test(id)
				? id
				: tokenEmployeeId != null
				? String(tokenEmployeeId)
				: "";

		if (resolvedEmployeeId && /^\d+$/.test(resolvedEmployeeId)) {
			dispatch(loadExpensesById(resolvedEmployeeId));
		}
	}, [dispatch, id]);

	// const handlePageChange = (page, pageSize) => {
	// 	setCurrentPage(page);
	// 	setPageSize(pageSize);
	//   };

	return (
		
			<div className="card">
				<div className="card-body">
					<CustomTable
						list={list}
						loading={loading}
					// currentPage={currentPage}
					// pageSize={pageSize}
					// onPageChange={handlePageChange}
					/>
				</div>
			</div>
		
	);
};

export default UserExpense;
